import script from "./LayerBulkFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./LayerBulkFiles.vue?vue&type=script&setup=true&lang=js"

import "./LayerBulkFiles.vue?vue&type=style&index=0&id=3ded1558&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ded1558"]])

export default __exports__